import { ContactPerson, ContactPersonInput } from '@iss/libs/graphql';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { DeepPartial } from '@iss/wo-common/types';
import { ControlsOf } from '@iss/core/forms';

export type ContactPersonControls = ControlsOf<ContactPersonInput>;

export class ContactPersonFormGroup extends FormGroup<ContactPersonControls> {
  public static create(value?: DeepPartial<ContactPerson>): ContactPersonFormGroup {
    return new this({
      role: new FormControl(value?.role || '', { nonNullable: true, validators: [ Validators.required ] }),
      firstName: new FormControl(value?.firstName, { nonNullable: true, validators: [ Validators.maxLength(255) ] }),
      surname: new FormControl(value?.surname, { nonNullable: true, validators: [ Validators.maxLength(255) ] }),
      email: new FormControl(value?.email || '', { nonNullable: true, validators: [ Validators.required, Validators.email ] }),
      phoneNumber: new FormControl(value?.phoneNumber, { nonNullable: true, validators: [ Validators.maxLength(255) ] }),
    });
  }
}
